import ApiService from '@/services/ApiService';
import { serialize } from '@/utils/helper';
export default {
  getMediaListOfCourse(data){
    const param = serialize(data);
    return ApiService().get(`/media/list?${param}`);
  },
  getMediaDetail(data) {
    const param = serialize(data);
    return ApiService().get(`/media?${param}`);
  },
  uploadUserMedia(data) {
    return ApiService().post("/media", data, true, "multipart/form-data");
  }
};